/**
 * Constants related to user functionality
 */

// import { getDirectMessageNotificationTypeId } from "@/utils/env";

export const REPORT_ORIGINS = {
  PROFILE: 'PROFILE',
  DM: 'DM',
  GROUP: 'GROUP',
  EVENT: 'EVENT',
} as const;

export const BW_GROUPS = ['Marketplace', 'Explorer Experiences'];

export type ReportOrigin = keyof typeof REPORT_ORIGINS; 

// export const directMessageNotificationTypeId = getDirectMessageNotificationTypeId();